export interface IconProps {
  fontSize?: 'inherit' | 'medium' | 'large' | 'small';
  className?: string;
}

export const sizeMap = {
  inherit: '1em',
  small: '20px',
  medium: '24px',
  large: '35px',
};